import { render, staticRenderFns } from "./EditTermsAndConditions.vue?vue&type=template&id=e0df1902&scoped=true&"
import script from "./EditTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./EditTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0df1902",
  null
  
)

export default component.exports